import {
  Component,
  Input,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { LazyImageService } from 'src/app/services/lazy-image.service';
import { NO_PHOTO, NoPhotoKind } from 'src/app/utils/no-photo';

@Component({
    selector: 'app-lazy-image',
    templateUrl: './lazy-image.component.html',
    styleUrls: ['./lazy-image.component.css'],
    standalone: false
})
export class LazyImageComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() imageUrl: string | null = null;
  @Input() isPriority: boolean | null = false;
  /** Блюдо или напиток: без фото — их векторная заглушка, как в приложении */
  @Input() kind: NoPhotoKind | null = null;
  imageSrc: string | null = null;

  get fallback(): string {
    return this.kind ? NO_PHOTO[this.kind] : 'assets/no_photo_ru.png';
  }

  get isFallback(): boolean {
    return this.imageSrc === this.fallback;
  }

  isLoading = false;
  private hasError = false;
  private hasLoaded = false;
  private isInView = false;
  private isRegistered = false;

  private observer: IntersectionObserver | null = null;

  constructor(
    private elRef: ElementRef,
    private imageCache: ImageCacheService,
    private lazyImageService: LazyImageService
  ) {}

  ngAfterViewInit(): void {
    const el = this.elRef.nativeElement;

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        // console.log(`LazyImageComponent | ngAfterViewInit() | isIntersecting: ${entries[0].isIntersecting} | isPriority: ${this.isPriority}`);
        this.isInView = true;
        this.loadImage('observer');
        this.observer?.disconnect();
      } else {
        // console.log(`LazyImageComponent | ngAfterViewInit() | isIntersecting: ${entries[0].isIntersecting} | isPriority: ${this.isPriority}`);
        this.isInView = false;
        if (!this.isRegistered) {
          this.lazyImageService.registerComponent(this);
          this.isRegistered = true;
        }
      }
    });

    this.observer.observe(el);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['imageUrl'] &&
      changes['imageUrl'].currentValue &&
      !this.hasLoaded &&
      this.isInView
    ) {
      this.loadImage('ngOnChanges');
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  async loadImage(caller: string = 'unknown'): Promise<void> {
    // console.log(`LazyImageComponent | loadImage() | called by: ${caller}`);
    // console.log(`  - hasLoaded: ${this.hasLoaded}`);
    // console.log(`  - isInView: ${this.isInView}`);
    // console.log(`  - isPriority: ${this.isPriority}`);

    if (this.hasLoaded || this.isLoading) {
      return;
    }

    if (!this.imageUrl?.trim()) {
      this.imageSrc = this.fallback;
      this.isLoading = false;
      this.hasError = true;
      this.hasLoaded = true;
      return;
    }

    this.isLoading = true;
    this.hasLoaded = true;

    try {
      const src = await this.imageCache.getImage(this.imageUrl, this.fallback);
      this.imageSrc = src;
      this.isLoading = false;
    } catch {
      this.imageSrc = this.fallback;
      this.isLoading = false;
      this.hasError = true;
    }
  }

  forceLoad(): void {
    if (!this.hasLoaded) {
      this.loadImage('forceLoad');
    }
  }
}